import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';

import {
	PrismButtonComponent,
	PrismDialogComponent,
	PrismInputComponent,
	PrismTextareaComponent,
	TextValueAccessor
} from '@shure/prism-angular-components';

import { FeatureRequestMainComponent } from './feature-request-main.component';

@NgModule({
	imports: [
		CommonModule,
		FlexLayoutModule,
		FormsModule,
		ReactiveFormsModule,
		TranslocoModule,
		TextValueAccessor,
		PrismInputComponent,
		PrismButtonComponent,
		PrismDialogComponent,
		PrismTextareaComponent
	],
	declarations: [FeatureRequestMainComponent],
	exports: [FeatureRequestMainComponent]
})
export class FeatureRequestModule {}
